import React from "react"
import "typeface-roboto"

import { LayoutFull } from "./LayoutFull"

export const Layout = ({ children }) => <LayoutFull>{children}</LayoutFull>
